<template>
  <v-app-bar light app clipped-left class="client-toolbar" fixed height="50" extension-height>
    <v-app-bar-nav-icon
      class="d-md-none"
      style="color: #000"
      @click="$store.state.drawer = !$store.state.drawer"></v-app-bar-nav-icon>
    <a
      :href="logoHref"
      :title="$t('logo_title')"
      target="_blank"
      class="d-flex align-center app-logo">
      <img class="img-logo" :src="logoSrc[0]" />
    </a>
    <app-breadcrumbs class="d-none d-sm-flex ml-2 ml-md-4 app-bar-breadcrumbs"></app-breadcrumbs>
    <v-spacer></v-spacer>
    <div style="display: flex" class="right-btns">
      <v-layout>
        <v-flex v-if="clientId && clientId !== -1">
          <v-btn
            depressed
            small
            :title="$t('menu.emails[1]')"
            to="/emails"
            icon
            @click="$SDK.track('email_clicked', { source_page: 'app_bar' })"
            style="color: #000"
            class="btn-email mr-3">
            <v-badge class="badge-email" v-model="emailFlag" color="error" overlap dot>
              <v-icon style="font-size: 20px">email</v-icon>
            </v-badge>
          </v-btn>
        </v-flex>
        <v-flex class="d-flex align-center">
          <v-menu open-on-hover bottom offset-y transition="slide-x-transition">
            <template v-slot:activator="{ on }">
              <div v-on="on" style="color: #000" class="d-flex align-center">
                <div style="width: 30px">
                  <v-icon color="#000" style="font-size: 20px">
                    {{
                      clientInfo.first_name || clientInfo.last_name || clientInfo.email
                        ? 'person outline'
                        : 'account_box'
                    }}
                  </v-icon>
                </div>
                <div>
                  {{
                    clientInfo.first_name && clientInfo.last_name
                      ? `${clientInfo.first_name} ${clientInfo.last_name}`
                      : clientInfo.email
                  }}
                </div>
              </div>
            </template>
            <v-list dense class="grey lighten-4">
              <template v-for="(item, i) in menus">
                <v-divider v-if="item.divider" :key="i"></v-divider>
                <v-list-item
                  v-else
                  :key="i"
                  :to="item.handler ? undefined : item.path"
                  @click="handleMenuItem(item)">
                  <v-list-item-action style="min-width: 36px">
                    <v-icon style="color: #000">{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t(item.text) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
    </div>
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex'
import { login, logout, signup } from '@/module/service/oAuth'
import { cloudclustersURL } from '@/module/constant'
import logo from '@/assets/images/logo.png'
import hwylogo from '@/assets/images/hwy_logo.png'
import dbmlogo from '@/assets/images/dbm_logo.png'
import AppBreadcrumbs from './AppBreadcrumbs.vue'

const logoMap = {
  ccs: [logo, 'https://images.cloudclusters.io/bcbdf56eed954923abe96490146509b5/ccs-small.png'],
  hwy: [hwylogo, 'https://images.cloudclusters.io/bcbdf56eed954923abe96490146509b5/ccs-small.png'],
  dbm: [
    dbmlogo,
    'https://images.cloudclusters.io/d00c3fd4543c48a589a1301df1e082a3/databasemart-small.png'
  ]
}

const menus = [
  // { icon: 'panorama_fish_eye', text: 'menu.account[1]', path: '/profile/account' },
  // { icon: 'keyboard', text: 'menu.password[0]', path: '/profile/password' },
  // { icon: 'panorama_fish_eye', text: 'menu.account[1]', path: '/account/information' },
  // { icon: 'keyboard', text: 'menu.password[0]', path: '/account/password' },
  { divider: true },
  {
    icon: 'logout',
    text: 'menu.logout[0]',
    handler: () => {
      logout()
    }
  },
  {
    icon: 'exit_to_app',
    text: 'menu.login[0]',
    noToken: true,
    preserveCheckout: true,
    handler: () => {
      login()
    }
  },
  {
    icon: 'people',
    text: 'menu.sign_up[0]',
    noToken: true,
    preserveCheckout: true,
    handler: () => {
      signup()
    }
  }
]

export default {
  name: 'AppBar',
  components: { AppBreadcrumbs },
  props: ['emailFlag'],
  i18n: {
    sharedMessages: {
      en: { logo_title: 'Professional Cloud Hosting Provider in the USA' },
      zh_CN: { logo_title: '美国专业的云托管提供商' }
    }
  },
  methods: {
    handleMenuItem(item) {
      // 认证跳转前同步保存当前结算页面的配置。
      if (item.preserveCheckout) this.$root.$emit('checkout:before-auth')
      if (item.handler) item.handler()
    }
  },
  computed: {
    logoHref() {
      return cloudclustersURL
    },
    logoSrc() {
      return logoMap[this.$project]
    },
    menus() {
      return menus.filter((o) => {
        return this.clientId === -1 || !this.clientId ? o.noToken : !o.noToken
      })
    },
    ...mapState('oAuth', ['clientId']),
    ...mapState('client', ['clientInfo'])
  }
}
</script>

<style scoped lang="scss">
.client-toolbar {
  box-shadow: none !important;
  border-bottom: 1px solid #d9d9d9;
  &.theme--light.v-app-bar.v-toolbar.v-sheet {
    background: #fff;
  }
  .app-logo {
    height: 100%;
    text-decoration: none;
    justify-content: center;
    .img-logo {
      max-width: 220px;
      height: 60px;
      object-fit: contain;
    }
  }
  // 桌面端抽屉常驻：去掉工具栏左内边距，让 logo 容器与抽屉列（270px）左边缘对齐并居中
  @media (min-width: 992px) {
    ::v-deep .v-toolbar__content {
      padding-left: 0;
    }
    .app-logo {
      width: 270px;
    }
  }
  .btn-email.v-btn--active {
    i {
      color: var(--v-primary-base);
    }
  }
  // 面包屑不换行、可收缩，避免超高或挤占右侧按钮
  .app-bar-breadcrumbs {
    min-width: 0;
    overflow: hidden;
  }
}
</style>
